export const FadeEffect = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const heroSection = document.querySelector('.page-home__hero');
        if (!heroSection) return;

        const banners = heroSection.querySelectorAll('.banner-wrapper');
        if (banners.length === 0) return;

        let currentIndex = 0;
        const fadeDuration = 700; // 1 second fade
        const displayDuration = 5000; // 5 seconds visible
        const overlapDuration = 1000; // 0.5 second overlap

        // Initialize: hide all except first
        banners.forEach((banner: HTMLElement, index) => {
            banner.style.opacity = index === 0 ? '1' : '0';
            banner.style.transition = `opacity ${fadeDuration}ms ease-in-out`;
        });

        function cycleBanners() {
            const current = banners[currentIndex] as HTMLElement;
            const nextIndex = (currentIndex + 1) % banners.length;
            const next = banners[nextIndex] as HTMLElement;

            // Fade in next BEFORE current fades out completely
            setTimeout(() => {
                next.style.opacity = '1';
            }, fadeDuration - overlapDuration);

            // Fade out current
            current.style.opacity = '0';

            currentIndex = nextIndex;
        }

        // Start cycling after initial display
        setInterval(cycleBanners, displayDuration + fadeDuration);
    });
}